import React, { useState } from 'react'
import { DropdownMenu } from '@paypalcorp/pp-react'
import { NewCodeBlockWrapper, NewCodeBlock } from '../components/layout'

const LanguageDropdown = ({
  curl = 'No snippet provided',
  go = 'No snippet provided',
  python = 'No snippet provided',
  ruby = 'No snippet provided',
  java = 'No snippet provided',
  javascript = 'No snippet provided',
}: any) => {
  const [selectedValue, setSelectedValue] = useState('curl')
  const [selectedSnippet, setSelectedSnippet] = useState(curl)
  const options = [
    { primaryText: 'cURL', value: 'curl' },
    { primaryText: 'Ruby', value: 'ruby' },
    { primaryText: 'Python', value: 'python' },
    { primaryText: 'Node', value: 'javascript' },
    { primaryText: 'Java', value: 'java' },
    { primaryText: 'Go', value: 'go' },
  ]
  const handleOnChange: React.EventHandler<any> = (event: any) => {
    setSelectedValue(event.target.value)
    const snippetMap: any = { curl, go, python, ruby, javascript, java }
    setSelectedSnippet(snippetMap[event.target.value])
  }

  if (selectedValue) {
    return (
      <NewCodeBlockWrapper>
        <div style={{ width: '240px', height: '80px' }}>
          <DropdownMenu
            id="withLoader"
            label="Select a language"
            style={{ maxWidth: '240px', width: '240px' }}
            options={options}
            value={selectedValue}
            onChange={handleOnChange}
          />
        </div>
        <NewCodeBlock
          className="language-java"
          children={`${selectedSnippet}`}
        />
      </NewCodeBlockWrapper>
    )
  }
  return <p>loading...</p>
}

export default LanguageDropdown
